// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ysB28-Header-module_root{position:relative}@media not (hover:hover){.ysB28-Header-module_root{border-top-left-radius:0;border-top-right-radius:0}}.OwCMo-Header-module_merchant{margin-bottom:1.6666666667rem}.wrpiE-Header-module_static{display:flex;flex-direction:column;justify-content:center;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "ysB28-Header-module_root",
	"merchant": "OwCMo-Header-module_merchant",
	"static": "wrpiE-Header-module_static"
};
export default ___CSS_LOADER_EXPORT___;
